import { render, staticRenderFns } from "./ExportMaterialModal.vue?vue&type=template&id=572ef563&scoped=true&"
import script from "./ExportMaterialModal.vue?vue&type=script&lang=js&"
export * from "./ExportMaterialModal.vue?vue&type=script&lang=js&"
import style0 from "./ExportMaterialModal.vue?vue&type=style&index=0&id=572ef563&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572ef563",
  null
  
)

component.options.__file = "ExportMaterialModal.vue"
export default component.exports